import { createAction } from '@reduxjs/toolkit';

import type { UpdateAsrSettingsPayload } from '@polyai/stream/commands/handlers/asr-settings/update-asr-settings/schema';

import { ASR_SETTINGS_SLICE_NAME } from './constants';

export const updateAsrSettings = createAction<UpdateAsrSettingsPayload>(
  `${ASR_SETTINGS_SLICE_NAME}/updateAsrSettings`,
);
